import React, { useState, useEffect } from 'react';
 

const LoadingPage = ({ onLoadingComplete, logoSrc = "/logo.svg"  }) => {
  const [loadingText, setLoadingText] = useState('Loading your parts catalog');
  const [imageError, setImageError] = useState(false);

  const loadingTexts = [
    'Loading your parts catalog',
    'Preparing engineering materials',
    'Setting up your workspace',
    'Almost ready'
  ];

  useEffect(() => {
    // Change loading text every 2 seconds
    const textInterval = setInterval(() => {
      setLoadingText(prev => {
        const currentIndex = loadingTexts.indexOf(prev);
        const nextIndex = (currentIndex + 1) % loadingTexts.length;
        return loadingTexts[nextIndex];
      });
    }, 2000);

    // Complete loading after 4 seconds
    const loadingTimeout = setTimeout(() => {
      if (onLoadingComplete) {
        onLoadingComplete();
      }
    }, 4000);

    return () => {
      clearInterval(textInterval);
      clearTimeout(loadingTimeout);
    };
  }, [onLoadingComplete]);

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <div className="loading-wrapper">
      {/* Floating Particles */}
      <div className="particles">
        {[...Array(9)].map((_, i) => (
          <div key={i} className="particle"></div>
        ))}
      </div>

      {/* Background Gears */}
      <div className="gear-background gear1">⚙</div>
      <div className="gear-background gear2">⚙</div>

      <div className="loading-container">
        <div className="logo-container">
          {!imageError && logoSrc ? (
            <img 
              src={logoSrc}
              alt="Asia Part Souq Logo" 
              className="logo-image"
              onError={handleImageError}
            />
          ) : (
            <div className="fallback-logo">
              <span className="asia-text">ASIA</span>
              <div className="part-souq-container">
                <span className="part-souq-text">PART</span>
                <span className="part-souq-text">SOUQ</span>
              </div>
            </div>
          )}
        </div>

        <div className="loading-spinner"></div>
        
        <div className="progress-bar">
          <div className="progress-fill"></div>
        </div>

        <div className="loading-text">
          {loadingText}<span className="dots">...</span>
        </div>
      </div>

      <style jsx>{`
        .loading-wrapper {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100vh;
          background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          z-index: 9999;
        }

        .loading-container {
          text-align: center;
          position: relative;
        }

        .logo-container {
          position: relative;
          margin-bottom: 40px;
          animation: logoFloat 3s ease-in-out infinite;
        }

        .logo-image {
          max-width: 350px;
          max-height: 120px;
          width: auto;
          height: auto;
          filter: drop-shadow(0 4px 8px rgba(0,0,0,0.3));
          animation: fadeInScale 1s ease-out;
        }

        .fallback-logo {
          display: flex;
          flex-direction: column;
          align-items: center;
          animation: fadeInScale 1s ease-out;
        }

        .asia-text {
          font-size: 3.5rem;
          font-weight: bold;
          color: #2855a3;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
          letter-spacing: 2px;
        }

        .part-souq-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: -10px;
        }

        .part-souq-text {
          font-size: 2rem;
          font-weight: bold;
          color: #e74c3c;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
          letter-spacing: 1px;
          line-height: 1;
        }

        .loading-spinner {
          width: 80px;
          height: 80px;
          border: 4px solid rgba(255,255,255,0.3);
          border-radius: 50%;
          border-top: 4px solid #e74c3c;
          border-right: 4px solid #2855a3;
          margin: 30px auto;
          animation: spin 1.5s linear infinite;
        }

        .loading-text {
          color: #ffffff;
          font-size: 1.1rem;
          margin-top: 20px;
          animation: pulse 2s ease-in-out infinite;
        }

        .dots {
          display: inline-block;
          animation: dots 1.5s infinite;
        }

        .gear-background {
          position: absolute;
          width: 200px;
          height: 200px;
          opacity: 0.1;
          animation: rotateGear 8s linear infinite;
          font-size: 200px;
          color: #ffffff;
        }

        .gear1 {
          top: -100px;
          left: -100px;
        }

        .gear2 {
          bottom: -100px;
          right: -100px;
          font-size: 150px;
          animation: rotateGear 6s linear infinite reverse;
        }

        .progress-bar {
          width: 300px;
          height: 4px;
          background: rgba(255,255,255,0.3);
          border-radius: 2px;
          margin: 30px auto;
          overflow: hidden;
          position: relative;
        }

        .progress-fill {
          height: 100%;
          background: linear-gradient(90deg, #2855a3, #e74c3c);
          border-radius: 2px;
          animation: progressFill 3s ease-in-out infinite;
        }

        .particles {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: -1;
        }

        .particle {
          position: absolute;
          width: 4px;
          height: 4px;
          background: rgba(255,255,255,0.5);
          border-radius: 50%;
          animation: float 6s infinite ease-in-out;
        }

        .particle:nth-child(1) { left: 10%; animation-delay: -1s; }
        .particle:nth-child(2) { left: 20%; animation-delay: -2s; }
        .particle:nth-child(3) { left: 30%; animation-delay: -3s; }
        .particle:nth-child(4) { left: 40%; animation-delay: -4s; }
        .particle:nth-child(5) { left: 50%; animation-delay: -5s; }
        .particle:nth-child(6) { left: 60%; animation-delay: 0s; }
        .particle:nth-child(7) { left: 70%; animation-delay: -1.5s; }
        .particle:nth-child(8) { left: 80%; animation-delay: -2.5s; }
        .particle:nth-child(9) { left: 90%; animation-delay: -3.5s; }

        /* Animations */
        @keyframes logoFloat {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }

        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.8);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.6; }
        }

        @keyframes dots {
          0%, 20% { content: '.'; }
          40% { content: '..'; }
          60%, 100% { content: '...'; }
        }

        @keyframes rotateGear {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @keyframes progressFill {
          0% { 
            width: 0%; 
            transform: translateX(-100%);
          }
          50% { 
            width: 70%; 
            transform: translateX(0%);
          }
          100% { 
            width: 100%; 
            transform: translateX(0%);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(100vh) rotate(0deg);
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          90% {
            opacity: 1;
          }
          100% {
            transform: translateY(-100px) rotate(360deg);
            opacity: 0;
          }
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .logo-image {
            max-width: 280px;
            max-height: 100px;
          }
          .asia-text {
            font-size: 2.5rem;
          }
          .part-souq-text {
            font-size: 1.5rem;
          }
          .progress-bar {
            width: 250px;
          }
        }

        @media (max-width: 480px) {
          .logo-image {
            max-width: 220px;
            max-height: 80px;
          }
          .asia-text {
            font-size: 2rem;
          }
          .part-souq-text {
            font-size: 1.3rem;
          }
          .loading-spinner {
            width: 60px;
            height: 60px;
          }
        }
      `}</style>
    </div>
  );
};

 
 

export default LoadingPage;